import yaml from "js-yaml";

import { FormResources } from "../types/formData";
// @ts-expect-error path does work
import yamlFile from "./valuation-manager-form.yaml";

export const getFormResources = async (): Promise<FormResources> => {
  try {
    const response = await fetch(yamlFile);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch ${yamlFile}: ${response.status} ${response.statusText}`,
      );
    }
    const yamlContent = await response.text();
    const formResources = yaml.load(yamlContent) as Promise<FormResources>;
    return formResources;
  } catch (error) {
    console.error("Error fetching YAML file:", error);
    throw new Error("Error fetching YAML file:" + error);
  }
};
